/* eslint-disable guard-for-in */
import React from 'react';

/* eslint-disable no-restricted-syntax */

const ForgotPassword = React.lazy(() => import('pages/auth/ForgotPassword'));
const ResetPassword = React.lazy(() => import('pages/auth/ForgotPassword/ResetPassword'));
const ChangePassword = React.lazy(() => import('pages/Settings/ChangePassword'));
const MaintenanceScreen = React.lazy(() => import('pages/Maintenance/MaintenanceScreen'));
const Profile = React.lazy(() => import('pages/Settings/Profile'));
const MapLayout = React.lazy(() => import('pages/Map'));
const DataManagementLayout = React.lazy(() => import('pages/DataManagement'));
const InputDataLayout = React.lazy(() => import('pages/InputData'));
const PestIdentificationLayout = React.lazy(() => import('pages/PestIdentification'));
const SettingManagementLayout = React.lazy(() => import('pages/SettingManagement'));
const StatisticManagementLayout = React.lazy(() => import('pages/StatisticManagement'));

const pathsConfig = {
  forgotpassword: {
    key: 'forgotpassword',
    name: 'ForgotPassword',
    path: 'forgot-password',
    component: <ForgotPassword />,
  },
  resetPassword: {
    key: 'resetpassword',
    name: 'ResetPassword',
    path: 'reset-password',
    component: <ResetPassword />,
  },
  dataManagement: {
    key: 'quan-ly-du-lieu',
    name: 'dataManagement',
    path: 'quan-ly-du-lieu',
    component: <DataManagementLayout />,
  },
  inputData: {
    key: 'nhap-lieu',
    name: 'inputData',
    path: 'nhap-lieu',
    component: <InputDataLayout />,
  },
  profile: {
    key: 'profile',
    name: 'Profile',
    path: 'settings/profile',
    component: <Profile />,
  },
  changePassword: {
    key: 'change-password',
    name: 'ChangePassword',
    path: 'settings/change-password',
    component: <ChangePassword />,
  },
  pestIdentification: {
    key: 'nhan-dien-sau-benh',
    name: 'pestIdentification',
    path: 'nhan-dien-sau-benh',
    component: <PestIdentificationLayout />,
  },
  map: {
    key: 'ban-do',
    name: 'thematicMap',
    path: 'ban-do',
    component: <MapLayout />,
  },
  statistic: {
    key: 'bieu-do',
    name: 'statisticManagement',
    path: 'bieu-do/bao-cao-thong-ke',
    component: <StatisticManagementLayout />,
  },
  setting: {
    key: 'cai-dat',
    name: 'settingNameMenu',
    path: 'cai-dat',
    component: <SettingManagementLayout />,
  },
  settings: {
    key: 'cai-dat',
    name: 'settingNameMenu',
    path: 'cai-dat/huong-dan-su-dung',
    component: <SettingManagementLayout />,
  },
  maintenance: {
    key: 'maintenance',
    name: 'Maintenance',
    path: 'maintenance',
    component: <MaintenanceScreen />,
  },
};

const getName = (path) => {
  let name = null;
  for (const property in pathsConfig) {
    const config = pathsConfig[property];
    if (config.path === path) {
      name = config.name;
      break;
    }
  }
  return name;
};

const getBreadcrumb = (path) => {
  let breadcrumb = null;
  for (const property in pathsConfig) {
    const config = pathsConfig[property];
    if (config.path === path) {
      breadcrumb = config.breadcrumb;
      break;
    }
  }
  return breadcrumb;
};

export { pathsConfig, getName, getBreadcrumb };
